import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  border: 1.5px solid ", ";\n  background: ", ";\n  width: 20px;\n  margin-left: auto;\n  position: relative;\n  top: 8px;\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-left: auto\n  &:before,\n  &:after {\n    content: \"\";\n    position: absolute;\n    background-color: #4F6E7C;\n    transition: transform 0.25s ease-out;\n  }\n  &:before {\n    top: 0;\n    left: 55%;\n    width: 3px;\n    height: 100%;\n    margin-left: -2px;\n  }\n  &:after {\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 3px;\n    margin-top: -2px;\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  width: 10%;\n  text-align: right;\n  ", "\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    display: ", "\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  width: 10%;\n  text-align: right;\n  ", "\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n  width: 20%;\n  text-align: left;\n  color: ", ";\n  font-weight: 600;\n  text-decoration: underline;\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  width: 20%;\n  text-align: left;\n  color: ", ";\n  font-weight: 600;\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  width: 25%;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.8);\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  width: 15%;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.8);\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  width: 15%;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.8);\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    width: 100px;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n    width: 90px;\n  "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    font-size: 15px;\n    line-height: 14px;\n  "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  width: 100px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.3);\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      font-size: 13px;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n      line-height: 120%;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  & > div {\n    color: ", ";\n    cursor: default;\n    font-size: 18px;\n    text-decoration: none;\n    font-weight: 400;\n    opacity: 1;\n    ", "\n    ", "\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      width: 200%;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px 0;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 10px 0;\n  flex-direction: row;\n  text-align: center;\n  justify-content: center;\n  align-items: flex-start;\n  cursor: pointer;\n  & > div:not(:last-child) {\n    margin-right: 12px;\n  }\n  & > div:nth-last-of-type(1) {\n    margin: 0;\n  }\n  ", "\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    width: ", ";\n    height: 100%;\n\n/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+99&1+50,0+100 */\nbackground: -moz-linear-gradient(left,  rgba(255,255,255,0) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,1) 99%); /* FF3.6-15 */\nbackground: -webkit-linear-gradient(left,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%,rgba(255,255,255,1) 99%); /* Chrome10-25,Safari5.1-6 */\nbackground: linear-gradient(to right,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 70%,rgba(255,255,255,1) 99%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\nfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */\n\n\n\n    left: 90.5%;\n    top: 0;\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    width: ", ";\n    height: 100%;\n    background: -moz-linear-gradient(left,  rgba(255,255,255,1) 0%, rgba(255,255,255,1) 70%, rgba(255,255,255,0.02) 99%, rgba(255,255,255,0) 100%); /* FF3.6-15 */\nbackground: -webkit-linear-gradient(left,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 70%,rgba(255,255,255,0.02) 99%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */\nbackground: linear-gradient(to right,  rgba(255,255,255,1) 0%,rgba(255,255,255,1) 70%,rgba(255,255,255,0.02) 99%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\nfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=1 ); /* IE6-9 */\n/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+99&0+0,1+50 */\nleft: -1px;\n    top: 0;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 40px;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      font-size: 13px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        margin-bottom: 20px;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      font-size: 14px;\n      line-height: 140%;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    overflow:scroll;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin: 0 1rem;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  & > div {\n    ", "\n  }\n  & > div:nth-child(2) {\n    & > div {\n      min-height: 55px;\n      & > div {\n        border-bottom: none;\n        min-height: 40px;\n      }\n    }\n  }\n  & > div:not(:last-child) {\n    margin-top: 30px;\n    font-size: 16px;\n    font-family: \"Inter\";\n    border-bottom: 1px solid ", ";\n    ", "\n    &.open {\n      border-bottom: none;\n      margin-bottom: 26px;\n      ", "\n    }\n    ", "\n  }\n  .account-order-details {\n    margin-bottom: 43px;\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.smallScreen(_templateObject2()), media.smallScreen(_templateObject3()), function (props) {
  return props.theme.colors.tableDivider;
}, media.xxLargeScreen(_templateObject4()), media.xLargeScreen(_templateObject5()), media.xLargeScreen(_templateObject6()), media.xLargeScreen(_templateObject7()));
export var BorderLeft = styled.span(_templateObject8(), media.smallScreen(_templateObject9(), function (props) {
  return !props.startScroll ? "0" : "10%";
}));
export var BorderRight = styled.span(_templateObject10(), media.smallScreen(_templateObject11(), function (props) {
  return props.endScroll ? "0" : "10%";
}));
export var Row = styled.div(_templateObject12(), media.xxLargeScreen(_templateObject13()), media.smallScreen(_templateObject14()));
export var HeaderRow = styled(Row)(_templateObject15(), function (props) {
  return props.theme.colors.tableDivider;
}, function (props) {
  return props.theme.colors.graySemi;
}, media.xxLargeScreen(_templateObject16()), media.xLargeScreen(_templateObject17()));
export var IndexNumber = styled.div(_templateObject18(), media.xxLargeScreen(_templateObject19()), media.xLargeScreen(_templateObject20()), media.smallScreen(_templateObject21()));
export var DateOfOrder = styled.div(_templateObject22());
export var Status = styled.div(_templateObject23());
export var Address = styled.div(_templateObject24());
export var Value = styled.div(_templateObject25(), function (props) {
  return props.theme.colors.baseFont;
});
export var Invoice = styled.div(_templateObject26(), function (props) {
  return props.theme.colors.baseFont;
});
export var Details = styled.div(_templateObject27(), media.smallScreen(_templateObject28(), function (props) {
  return !props.endScroll ? "none" : "block";
}));
export var Action = styled.div(_templateObject29(), media.smallScreen(_templateObject30(), function (props) {
  return !props.endScroll && "\n  position: absolute;\n    left: 97%;\n  ";
}));
export var Plus = styled.div(_templateObject31());
export var Minus = styled.div(_templateObject32(), function (props) {
  return props.theme.colors.red;
}, function (props) {
  return props.theme.colors.red;
});
export var ArrowLeft = styled.span(_templateObject33(), media.smallScreen(_templateObject34(), function (props) {
  return props.startScroll && "\n        position: absolute;\n        left: -25px;\n        &:after {\n          content: \" \";\n    border: solid #2C2C2C;\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    opacity: 0.5;\n    transform: rotate(135deg);\n        }\n    ";
}));
export var ArrowRight = styled.span(_templateObject35(), media.smallScreen(_templateObject36(), function (props) {
  return !props.endScroll && "\n    position: absolute;\n    left: 104%;\n    &:after {\n      content: \" \";\n    border: solid #2C2C2C;\n    border-width: 0 2px 2px 0;\n    display: inline-block;\n    padding: 3px;\n    opacity: 0.5;\n    transform: rotate(-45deg);\n    }\n";
}));